import { useEffect, useState } from 'react';
import styles from './SteamAddingPage.module.css';

import { getRates } from '../../../utils/getRates.js';
import { useCreateAddingOrderMutation } from '../../../store/api/addingOrder.api.js';
import { useUserDataBlurHandler } from '../../../hooks/useUserDataBlurHandler.js';
import { useGetUserByIdQuery } from '../../../store/api/user.api.js';
import { useSelector } from 'react-redux';

import { DataInput } from '../../../UI/DataInput/DataInput.jsx';
import { Header } from '../../../components/Header/Header.jsx';
import { TextDropbox } from '../../../UI/TextDropbox/TextDropbox.jsx'
import { CommissionBar } from '../../../components/CommissionBar/CommissionBar.jsx';
import { BlueBtn } from '../../../UI/BlueBtn/BlueBtn.jsx';
import { FooterBtn } from '../../../UI/FooterBtn/FooterBtn.jsx'
import { Link } from 'react-router-dom';

import addingIcon from '../../../assets/adding-icon.svg';
import steamIcon from '../../../assets/steam_input-icon.svg'
import addingInputIcon from '../../../assets/adding_input-icon.svg'
import checkboxIcon from '../../../assets/checkbox-icon.svg';
import checkboxActiveIcon from '../../../assets/checkboxActive-icon.svg';
import FAQIcon from '../../../assets/FAQ_footer-icon.svg';
import supIcon from '../../../assets/support-icon.svg';


export const SteamAddingPage = ({ setIsFocus }) => {
	const { id } = useSelector(state => state.user.user);
	const { data: user, refetch } = useGetUserByIdQuery(id);

	const [loginValue, setLoginValue] = useState('')
	const [netAmount, setNetAmount] = useState('')
	const [amount, setAmount] = useState('')
	const [amountWithCommission, setAmountWithCommission] = useState('')
	const [rates, setRates] = useState()
	const [checkboxAgree, setCheckboxAgree] = useState(false)
	const [currencyActive, setCurrencyActive] = useState(0);

	const [createAddingOrder, { isLoading }] = useCreateAddingOrderMutation();
	const { handleBlur } = useUserDataBlurHandler({
		checkbox: true,
		userRefetch: refetch,
	});

	useEffect(() => {
		if (user) {
			setLoginValue(user.steamLogin);
		}
	}, [user])

	const addingOrderCreate = async () => {
		const currency = currencyActive === 0 ? "RUB" : "KZT";

		const data = {
			amount: Number(amountWithCommission),
			netAmount: Number(netAmount),
			currency,
			inShopInfo: {
				login: loginValue
			}
		}

		const order = await createAddingOrder({ data });
		console.log(order);
		const url = order?.data?.paymentUrl;

		if (url) {
			window.Telegram?.WebApp?.openLink(url);
		} else if(order?.error?.status === 400) {
			alert(order.error.data.message);
		} else {
			alert('Ошибка при пополнеии Steam');
		}
	}

	const calculateAmount = (netAmount, currencyActive, rates) => {
		const numNet = Number(netAmount);
		if (!numNet || !rates) return '0';

		let withoutCommission = numNet * 1.06;
		setAmountWithCommission(withoutCommission.toFixed(2));
		if (currencyActive === 1 && rates.KZT_RUB) {
			withoutCommission *= Number(rates.KZT_RUB);
		}

		return withoutCommission.toFixed(2);
	};

	useEffect(() => {
		setAmount(calculateAmount(netAmount, currencyActive, rates));
	}, [netAmount, currencyActive, rates])

	useEffect(() => {
		window.sessionStorage.setItem('schema', 'steam');

		getRates().then((data) => setRates(data))
	}, []);

	return (
		<div className='main' style={{ marginBottom: 100 }}>
			<Header />
			<div className={'title_block'}>
				<img src={addingIcon} alt="addingIcon" />
				<h2>Пополнения Steam</h2>
			</div>
			<div className={styles.mainBlock}>
				<DataInput
					text={'Логин Steam'}
					type={'text'}
					img={steamIcon}
					value={loginValue}
					onChange={value => setLoginValue(value)}
					onBlur={value => handleBlur('steamLogin', value)}
					bg={'#171717'}
				/>
				<TextDropbox title={'Инструкция'} >
					<ul className={styles.manual}>
						<li>1. Введите свой логин аккаунта. (как узнать логин?)</li>
						<li>2. Введите сумму, которую вы хотите получить на баланс Steam.</li>
						<li>3. Проверьте, что указали именно логин, а не никнейм.</li>
						<li>4. Нажмите кнопку «Пополнить».</li>
						<li>5. Вы перейдете на страницу сервиса, где необходимо выбрать метод оплаты.</li>
						<li>6. После успешной оплаты деньги поступят на баланс аккаунта в течение 2-15 минут. При возникновении вопросов <span>свяжитесь с поддержкой.</span></li>
					</ul>
				</TextDropbox>
				<DataInput
					text={'Сумма пополнения '}
					type={'numeric'}
					img={addingInputIcon}
					value={netAmount}
					onChange={value => setNetAmount(value)}
					bg={'#171717'}
					currencyActive={currencyActive}
					setCurrencyActive={setCurrencyActive}
					setIsFocus={setIsFocus}
				/>
				<div className={styles.payForm}>
					<p className={styles.forPay}>К оплате</p>
					<h2>{amount || 0} ₽</h2>
					<BlueBtn
						type='steamAdding'
						isLoading={isLoading}
						price={amount}
						addingOrderCreate={addingOrderCreate}
						text={`Оплатить ${amount || 0} ₽`}
						disabled={!checkboxAgree || !loginValue || !netAmount}
					/>
					<div className={styles.line}></div>
					<div className={styles.agree_block} onClick={() => setCheckboxAgree(!checkboxAgree)}>
						{checkboxAgree ? (
							<img src={checkboxActiveIcon} alt="checkboxActiveIcon" />
						) : (
							<img src={checkboxIcon} alt="checkboxIcon" />
						)}
						<p>Я согласен с условиями <Link to={'/userAgree'} style={{ color: "#0ea5e9" }}> пользовательского соглашения </Link> и <Link to={'/privacyPolicy'} style={{ color: "#0ea5e9" }}>политики конфиденциальности</Link> </p>
					</div>
				</div>
				<footer className={styles.footer}>
					<FooterBtn
						img={FAQIcon}
						title={'FAQ'}
						description={'Вопросы'}
						width={135}
						height={140}
						url={'/FAQ'}
					/>
					<FooterBtn img={supIcon} title={'Support'} description={'На всякий, если у вас будут вопросы'} width={209} />
				</footer>
			</div>
		</div>
	);
};